import React from 'react';
import { FadeIn } from './FadeIn';
import { ShieldCheck } from 'lucide-react';
export function GuaranteeBlock() {
  return <section className="bg-white py-12 sm:py-16 px-4" data-id="element-152">
      <div className="max-w-content mx-auto text-center" data-id="element-153">
        <FadeIn data-id="element-154">
          <div className="inline-flex items-center justify-center w-20 h-20 rounded-full bg-brand-primary/10 mb-6" data-id="element-155">
            <ShieldCheck className="w-10 h-10 text-brand-accent" strokeWidth={1.5} data-id="element-156" />
          </div>

          <h2 className="text-2xl sm:text-3xl font-serif font-bold text-brand-text mb-6" data-id="element-157">
            Garantía Total de 7 Días
          </h2>

          <p className="text-brand-text/80 text-lg leading-relaxed max-w-lg mx-auto mb-8" data-id="element-158">
            Si aplicas el método y sientes que no fue lo que esperabas, te
            devolvemos tu dinero sin preguntas. Así de seguros estamos de que
            esto va a cambiar cómo te ves y cómo te sientes cada mañana.
          </p>

          <div className="inline-block bg-brand-accent text-white font-bold py-2 px-6 rounded-full text-sm tracking-wide uppercase shadow-sm" data-id="element-159">
            100% Libre de Riesgo
          </div>
        </FadeIn>
      </div>
    </section>;
}